import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * 文档历史列表UI组件
 * 纯展示型组件，负责渲染文档历史记录列表
 */
import React from 'react';
import { Button } from '../../core/Button/index.js';
// Remove Row component and its props
// interface RowProps { ... }
// const Row = React.memo(...) { ... };
/**
 * 文档历史列表UI组件 (更新 - 移除虚拟化, 使用 renderItem)
 */
export const DocumentHistoryListUI = ({ documents, isLoading, error, renderItem, // Use renderItem
hasMore, // 新增
onLoadMore, // 新增
isLoadingMore, // 新增
className = '', totalCount, // Destructure totalCount
 }) => {
    // Remove formatDate function, it's handled by the component returned by renderItem
    // 加载状态 (只显示初始加载)
    if (isLoading && documents.length === 0) {
        return _jsx("div", { className: "text-center py-4 text-gray-600", children: "Loading history..." });
    }
    // 错误状态
    if (error) {
        return _jsx("div", { className: "text-center py-4 text-interactive-coral-red", children: error });
    }
    // 空数据状态 (且不在加载中)
    if (!isLoading && documents.length === 0) {
        return _jsx("div", { className: "text-center py-4 text-gray-600", children: "No reading history" });
    }
    // 渲染列表和加载更多按钮
    return (_jsxs("div", { className: `history-list ${className}`, children: [totalCount !== undefined && totalCount >= 0 && (_jsxs("div", { className: "mb-4 text-sm text-gray-600", children: ["Total ", totalCount, " histories"] })), _jsx("ul", { className: "space-y-3", children: documents.map(doc => (
                // Call renderItem to render the actual list item content
                // Key is now required here
                _jsx(React.Fragment, { children: renderItem(doc) }, `${doc.identity.type}-${doc.identity.id}`))) }), hasMore && onLoadMore && (_jsx("div", { className: "text-center pt-4", children: _jsx(Button, { variant: "secondary", onClick: onLoadMore, loading: isLoadingMore, disabled: isLoading || isLoadingMore, children: isLoadingMore ? 'Loading...' : 'Load More' }) }))] }));
};
export default DocumentHistoryListUI;
//# sourceMappingURL=DocumentHistoryListUI.js.map